<script>
import TablePrivilegeAPI from "@/services/table-privilege-api"
import CampaignApi from "@/services/campaign-api";

export default {
  components: {  },
  
  props : {
        campaign:{
          type:Object,
          default:() => null,
      },
    },

  data() {
    return {
        tablePrivilegeList:[],
        fields: [
            { key: "name", tdClass: "font-weight-bold text-dark", thClass: "text-left text-dark" },
            { key: "timestamp", tdClass: "text-center text-dark", thClass: "text-center text-dark" },
            { key: "startTable", tdClass: "text-left text-dark", thClass: "text-left text-dark" },
            { key: "endTable", tdClass: "text-left text-dark", thClass: "text-left text-dark" },
            { key: "action", tdClass: "text-right text-dark", thClass: "text-right text-dark" }
        ],
        settingsCampaign: {
                id: this.campaign ? this.campaign.id : null,
                secretMenuCode: this.campaign ?  this.campaign.secretMenuCode : null,},

    };

  },
  mounted(){
    this.getUserTablePrivilege()
  },

  watch:{

    campaign: function(){
        if(this.campaign){
        this.settingsCampaign = this.campaign
        this.getUserTablePrivilege()
        }
    },


  },

    computed: {
        role() {
        return this.$cookies.get('userr');
        },
    },

  methods:{


    saveMenuSecretCode(){
        CampaignApi.saveMenuSecretCode({campaignId: this.campaign.id, secretMenuCode: this.settingsCampaign.secretMenuCode}).then((result) =>{
            if(result){
                this.$snotify.success("Code secret enregistré avec succès")
            }
        })
    },

    resetPermission(item){
        item.startTable=null
        item.endTable=null

        this.updateUserTablePrivilege(item)
    },

    updateUserTablePrivilege(data){
        
        TablePrivilegeAPI.updateUserTablePrivilege(data).then((result) =>{
            if(result){
                this.tablePrivilegeList = result
            }
        })
    },


    getUserTablePrivilege(){

        if(!this.campaign || !this.campaign.id){
            return
        }

        TablePrivilegeAPI.getUserTablePrivilege(this.campaign.id).then((result) =>{
            if(result){
                this.tablePrivilegeList = result
            }
        })
    },
  }

};
</script>
<template>
    <div class="card "  v-if="role == 1 || campaign.isCustomerAdmin">
        <div class="card-body " >
        
            <div class="row">
                <div class="col-md-8 col-12">
                    <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('privilegeTable.title')}}  </h2>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-2 text-right">
                    <b-button variant="primary" @click="saveSettingsCampain()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 font-weight-bold text-uppercase">
                        {{$t("buttons.save")}}
                    </b-button>
                </div>

            </div>
            


            <div class=" mb-3 mt-3">
                <label for="code-secret" class="form-label text-dark">Code Secret</label>
                <b-form-input
                    id="code-secret"
                    v-model="settingsCampaign.secretMenuCode"
                    type="text"
                    placeholder="Entrez votre code secret"
                    class="col-lg-2 col-md-4 col-sm-6 col-12"
                ></b-form-input>
                <small class="form-text text-muted">
                    Ce code est requis pour modifier ou annuler votre commande.
                </small>
            </div>




            <div class="table-responsive mt-4" style="max-height:31em; min-height:31em;">
                <b-table
                :items="tablePrivilegeList"
                :fields="fields"
                    :striped="false"
                    :small="false"
                    :hover="false"
                responsive
                
                :busy="false"
                >
                <!-- Spinner -->
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                    <b-spinner small variant="primary" role="status"></b-spinner>
                    </div>
                </template>

                <!-- Headers -->
                <template v-slot:head(name)>
                    {{ $t("privilegeTable.fields.name") }}
                </template>
                <template v-slot:head(startTable)>
                    {{ $t("privilegeTable.fields.startTable") }}
                </template>
                <template v-slot:head(endTable)>
                    {{ $t("privilegeTable.fields.endTable") }}
                </template>
                <template v-slot:head(timestamp)>
                    {{ $t("privilegeTable.fields.timestamp") }}
                </template>

                <!-- Editable cells -->
                <template v-slot:cell(startTable)="{ item }">
                    <b-form-input
                        v-model.number="item.startTable"
                        type="number"
                        size="md"
                        class="border-1 p-1 bg-white text-right"
                        style="max-width: 100px;"
                    />

                </template>

                <template v-slot:cell(endTable)="{ item }">
                    <b-form-input
                        v-model.number="item.endTable"
                        type="number"
                        size="md"
                        class="border-1 p-1 bg-white text-right"
                        style="max-width: 100px;"
                    />
                </template>

                <template v-slot:cell(timestamp)="{ value }">
                    <div class="text-center">{{ value ?  value : '-' }}</div>
                </template>

                <template v-slot:cell(action)="{ item }">
                    <b-button
                    size="sm"
                    variant="outline-primary"
                    class="mr-1"
                    @click="updateUserTablePrivilege(item)"
                    title="Enregister les permissions"
                    >
                    ✔
                    </b-button>
                    <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="resetPermission(item)"
                    title="Réinitialiser les permissions"
                    >
                    ✖
                    </b-button>
                </template>
                </b-table>

                <!-- Empty table -->
                <div v-if="!tablePrivilegeList || !tablePrivilegeList.length" class="text-center text-muted m-3">
                {{ $t("privilegeTable.emptyTable") }}
                </div>
            </div>

        </div>
    </div>
</template>

